<template>
  <b-modal
    id="annonce-online-modal"
    class="online-full-screen-modal"
    header-class="online-modal-header"
    ref="modal"
    @ok="handleOk"
    centered
    no-close-on-esc
    no-close-on-backdrop
    ok-variant="primary">

    <template #modal-header="{ close }">
      <div  class="online-modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/img-perso-ok.png`)" class="online-modal-img" >
        <div class="online-container h-100">
          <h1 class="page-title mt-4 ml-4 online-modal-subtitle">{{$t(getModalTitle())}}</h1>
        </div>
      </div>
    </template>

    <div>
      <p class="modal-annonce-text mt-2" v-html="$t(getModalContent())"></p>

      <p class="modal-annonce-text-offline" v-html="$t('payment_successful_dialog_reminder')"></p>
    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button  class="w-100" variant="primary"  @click="handleOk($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('Continue')}}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import i18n from "../../i18n";

export default {
  data() {
    return {
    };
  },

  props:{
    annonces:{
      required: true,
      type: Array
    }
  },

  methods: {
    getModalTitle(){
      if(this.hasMultipleAnnonces()) {
       return this.hasIncompleteAnnonces() ? 'payment_successful_dialog_incomplete_title_plural' : 'payment_successful_dialog_complete_title_plural'
      }
      return this.hasIncompleteAnnonces() ? 'payment_successful_dialog_incomplete_title' : 'payment_successful_dialog_complete_title'
    },

    getModalContent(){
      if(this.hasMultipleAnnonces()) {
        return this.hasIncompleteAnnonces() ? 'payment_successful_dialog_incomplete_description_plural' : 'payment_successful_dialog_complete_description_plural'
      }
      return this.hasIncompleteAnnonces() ? 'payment_successful_dialog_incomplete_description' : 'payment_successful_dialog_complete_description'
    },

    hasMultipleAnnonces(){
      return (this.annonces.length > 1)
    },
    hasIncompleteAnnonces(){
      for(const annonce of this.annonces){
        if(annonce.isComplete === false) return true
      }
      return false
    },

    async handleOk(e) {
      e.preventDefault()
      await this.$router.push({
        name: 'MyAnnonce'
      })
      this.$bvModal.hide('annonce-online-modal')

    },

  },
};
</script>

<!-- not scoped car modal --><style>

.modal-annonce-text-offline{
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  margin-top: 2em;
  color: var(--main-grey-medium);
}


.custom-span-checkbox{
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: var(--main-grey-medium);
}

#annonce-online-modal .modal-header{
  background-color: var(--main-black-light) !important;
  padding-bottom: 0px;
}

#annonce-online-modal .modal-content,
#annonce-online-modal .modal-body,
#annonce-online-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.online-modal-subtitle{
  font-size: 24px;
}

.online-modal-img{
  max-width: 200px;
}
#annonce-online-modal .online-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}


.online-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#annonce-online-modal .modal-annonce-text{
  color: var(--main-grey-light);
}

.online-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.online-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  .online-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .online-container img {
    order: 2;
    align-self: center;
  }
  .online-container {
    text-align: center;
  }
}

#annonce-online-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.online-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.online-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #annonce-online-modal .modal-content {
    display: flex;
    overflow: auto;
  }
  #annonce-online-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-online-modal .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #annonce-online-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #annonce-online-modal .modal-header {
    padding-top: 0px;
  }
  .online-modal-img {
    margin-top: 20px;
    align-self: end;
  }
  .online-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0px !important;
  }
  #annonce-online-modal .modal-content {
    margin: 8px;
  }
  #annonce-online-modal .modal-annonce-text, #annonce-online-modal .online-container {
    padding: 10px;
  }
  #annonce-online-modal .online-modal-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #annonce-online-modal .modal-content {
    overflow: auto;
  }
  .title-step4{
    font-size: 24px!important;
  }

  .online-modal-subtitle{
    font-size: 18px;
  }
  .online-modal-header-content, #annonce-online-modal .modal-annonce-text, .online-container {
    padding: 2px;
  }
}





</style>



// WEBPACK FOOTER //
// src/components/annonce/AnnonceOnlineModal.vue